module.exports = __webpack_public_path__ + "static/media/illustration-phone.51c32977.svg";